export default class CatalogModelValueConst {
 
    static MODELVALUE_DATASOURCE='modelvalue-datasource'
    static MODELVALUE_PROPERTY='modelvalue-property'
    
    }
    